"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = require("prop-types");
var _style = require("../../style");
var _GetIconComponent = _interopRequireDefault(require("../../util/GetIconComponent"));
var _textProcessing = require("../../../../../helpers/textProcessing");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var ListTips = function ListTips(_ref) {
  var list = _ref.list,
    iconAction = _ref.iconAction;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.ListBubble, {
    children: list.map(function (item, index) {
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("li", {
        children: [item.icon && (0, _GetIconComponent["default"])(item.icon, iconAction), /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.Text, {
          children: (0, _textProcessing.urlify)(item.text, true, true)
        })]
      }, index);
    })
  });
};
ListTips.propTypes = {
  list: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    icon: _propTypes.string.isRequired,
    text: _propTypes.string.isRequired
  })).isRequired
};
var _default = exports["default"] = ListTips;